document.addEventListener('click', function (event) {
  const openBtn = event.target.closest('[data-yp-modal-open]');
  if (openBtn) {
    const dialog = document.getElementById(openBtn.getAttribute('data-yp-modal-open'));
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  }

  const closeBtn = event.target.closest('[data-yp-modal-close]');
  if (closeBtn) {
    const dialog = closeBtn.closest('dialog');
    if (dialog) dialog.close();
  }
});

document.addEventListener('click', function (event) {
  const dialog = event.target.closest('dialog.yp-brand-modal');
  if (!dialog) return;
  const rect = dialog.getBoundingClientRect();
  const inDialog =
    rect.top <= event.clientY &&
    event.clientY <= rect.top + rect.height &&
    rect.left <= event.clientX &&
    event.clientX <= rect.left + rect.width;
  if (!inDialog && dialog.open) dialog.close();
});

document.addEventListener('click', function (event) {
  const scrollBtn = event.target.closest('[data-yp-scroll-top]');
  if (scrollBtn) window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.addEventListener('toggle', function (event) {
  const current = event.target;
  if (!(current instanceof HTMLDetailsElement) || !current.classList.contains('yp-brand-nav__item') || !current.open) return;
  document.querySelectorAll('.yp-brand-nav__item[open]').forEach(function (item) {
    if (item !== current) item.removeAttribute('open');
  });
}, true);
